export * from '@primeuix/themes/lara/knob';
export { default } from '@primeuix/themes/lara/knob';
